import React, { useContext, useEffect, useState } from "react";
import Heading from "../../../Components/Heading/Heading";
import SelectForm from "../../../Components/SelectForm/SelectForm";
import DynamicGrid from "../../../Components/DynamicGrid/DynamicGrid";
import { Tooltip } from "@mui/material";
import moment from "moment";
import { LoaderContext, getContext } from "../../../Helpers/Context/Context";
import {
  GetRequirementReportExportToExcel,
  getCustomerDropdownForRequirementReport,
  getEngagementDropdownForRequirementReport,
  getRequirmentReportGridData,
} from "../../../Helpers/API/APIEndPoints";
import { APICall } from "../../../Helpers/API/APICalls";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import fileDownload from "js-file-download";

function RequirementReport() {
  const { EmployeeId, RoleId } = getContext();
  const [customerOptions, setCustomerOptions] = useState<any>([]);
  const [customerSelectData, setCustomerSelectData] = useState<any>({});
  const [EngagementOptions, setEngagementOptions] = useState<any>([]);
  const [selectedEngagement, setSelectedEngagement] = useState<any>({});
  const [FormErrors, setFormErrors] = useState<any>({});
  const [page, setPage] = useState(0);
  const [start, setStart] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [sortColumn, setSortColumn] = useState("");
  const [count, setCount] = useState(0);
  const [sortDirection, setSortDirection] = useState("");
  const [searchText, setSearchText] = useState("");
  const [RequirementReportData, setRequirementReportData] = useState<any>([]);
  const { showLoader, hideLoader } = useContext(LoaderContext);
  let navigate = useNavigate();

  const options = {
    selectableRows: "none",
    start: start,
    page: page,
    count: count,
    rowsPerPage: pageSize,
    serverSide: true,
    rowsPerPageOptions: [],
    download: false,
    print: false,
    viewColumns: false,
    filter: false,
    search: true,
    onChangeRowsPerPage: (num) => {
      //   setLimit(num);
      //   setNxtPgInfo("");
      //   setPrevPgInfo("");
      //   setIsPrevOrNext("");
    },
    onSearchChange: (searchText) => {
      if (searchText !== null) {
        setSearchText(searchText);
        setStart(0);
      } else {
        setSearchText("");
      }
    },
    onColumnSortChange: async (sortColumn, sortDirection) => {
      if (sortDirection === "asc") {
        await setSortColumn(sortColumn);
        await setSortDirection(sortDirection);
      }
      if (sortDirection === "desc") {
        await setSortColumn(sortColumn);
        await setSortDirection(sortDirection);
      }
    },
    onChangePage: async (page) => {
      setPage(page);
      setStart(page * pageSize);
    },
  };

  const gridColumns = [
    {
      name: "id",
      label: "Id",
      options: {
        display: false,
        filter: false,
        sort: false,
      },
    },
    {
      name: "title",
      label: "Title",
      options: {
        filter: false,
        sort: true,
        sortDescFirst: true,
      },
    },
    {
      name: "status",
      label: "Status",
      options: {
        filter: false,
        sort: false,
        sortDescFirst: false,
      },
    },
    {
      name: "estimate_Mandays",
      label: "Estimate Mandays",
      options: {
        filter: false,
        sort: false,
        sortDescFirst: false,
      },
    },
    {
      name: "actual_Mandays",
      label: "Actual Mandays",
      options: {
        filter: false,
        sort: false,
        sortDescFirst: false,
      },
    },
    {
      name: "unplannedTask_Mandays",
      label: "UnplannedTask Mandays",
      options: {
        filter: false,
        sort: false,
        sortDescFirst: false,
      },
    },
    {
      name: "pendingTestCases",
      label: "Pending TestCases",
      options: {
        filter: false,
        sort: false,
        sortDescFirst: false,
      },
    },
    {
      name: "issue_Mandays",
      label: "Issue Mandays",
      options: {
        filter: false,
        sort: false,
        sortDescFirst: false,
      },
    },
  ];

  const GetEngagementDropdown = async () => {
    if (RoleId.includes(3)) {
      const obj = {
        EmpId: Number(EmployeeId),
        RoleId: 3,
        CustomerId: customerSelectData.value,
      };

      let data = await APICall(
        getEngagementDropdownForRequirementReport,
        "POST",
        obj
      );

      if (data.data.length > 0) {
        let tempArray = [];
        await data.data.map((d: any) => {
          let tempObj = {
            label: d.engagement,
            value: d.id,
          };
          tempArray.push(tempObj);
        });
        setEngagementOptions(tempArray);
      }
    } else if (RoleId.includes(2)) {
      const obj = {
        EmpId: Number(EmployeeId),
        RoleId: 2,
        CustomerId: customerSelectData.value,
      };

      let data = await APICall(
        getEngagementDropdownForRequirementReport,
        "POST",
        obj
      );

      if (data.data.length > 0) {
        let tempArray = [];
        await data.data.map((d: any) => {
          let tempObj = {
            label: d.engagement,
            value: d.id,
          };
          tempArray.push(tempObj);
        });
        setEngagementOptions(tempArray);
      }
    }
    //added by mahesh
    if (RoleId.includes(8)) {
      const obj = {
        EmpId: Number(EmployeeId),
        RoleId: 8,
        CustomerId: customerSelectData.value,
      };

      let data = await APICall(
        getEngagementDropdownForRequirementReport,
        "POST",
        obj
      );

      if (data.data.length > 0) {
        let tempArray = [];
        await data.data.map((d: any) => {
          let tempObj = {
            label: d.engagement,
            value: d.id,
          };
          tempArray.push(tempObj);
        });
        setEngagementOptions(tempArray);
      }
    }
    //end
  };

  const GetCustomerDropdown = async () => {
    if (RoleId.includes(3)) {
      const obj = {
        EmpId: Number(EmployeeId),
        RoleId: 3,
      };

      let data = await APICall(
        getCustomerDropdownForRequirementReport,
        "POST",
        obj
      );

      if (data.data.length > 0) {
        let tempArray = [];
        await data.data.map((d: any) => {
          let tempObj = {
            label: d.customer,
            value: d.customerId,
          };

          tempArray.push(tempObj);
        });
        setCustomerOptions(tempArray);
      }
    }
    // added RoleId.includes(8) by mahesh
    else if (RoleId.includes(8)) {
      const obj = {
        EmpId: Number(EmployeeId),
        RoleId: 8,
      };
      let data = await APICall(
        getCustomerDropdownForRequirementReport,
        "POST",
        obj
      );

      if (data.data.length > 0) {
        let tempArray = [];
        await data.data.map((d: any) => {
          let tempObj = {
            label: d.customer,
            value: d.customerId,
          };
          tempArray.push(tempObj);
        });
        setCustomerOptions(tempArray);
      }
    } //end
    else if (RoleId.includes(2)) {
      const obj = {
        EmpId: Number(EmployeeId),
        RoleId: 2,
      };
      let data = await APICall(
        getCustomerDropdownForRequirementReport,
        "POST",
        obj
      );

      if (data.data.length > 0) {
        let tempArray = [];
        await data.data.map((d: any) => {
          let tempObj = {
            label: d.customer,
            value: d.customerId,
          };
          tempArray.push(tempObj);
        });
        setCustomerOptions(tempArray);
      }
    }
  };

  useEffect(() => {
    (async () => {
      await GetCustomerDropdown();
    })();
  }, []);

  useEffect(() => {
    (async () => {
      await GetEngagementDropdown();
    })();
  }, [customerSelectData]);

  useEffect(() => {
    (async () => {
      await GetRequirementReportGridData();
    })();
  }, [sortColumn, sortDirection, page, start, searchText]);

  const selectOnChange = async (event: any, apiFieldName: any) => {
    if (apiFieldName === "customer") {
      setCustomerSelectData(event);
      setSelectedEngagement({});

      if (event && Object.keys(event).length > 0) {
        setFormErrors((preState) => ({
          ...preState,
          ["customer_isEmpty"]: undefined,
        }));
        setPage(0);
        setStart(0);
      } else if (!event || Object.keys(event).length === 0) {
        setFormErrors((preState) => ({
          ...preState,
          ["customer_isEmpty"]: "Customer can not be empty",
        }));
      }
    }

    if (apiFieldName === "engagement") {
      setSelectedEngagement(event);

      if (event && Object.keys(event).length > 0) {
        setFormErrors((preState) => ({
          ...preState,
          ["engagement_isEmpty"]: undefined,
        }));
        setPage(0);
        setStart(0);
      } else if (!event || Object.keys(event).length === 0) {
        setFormErrors((preState) => ({
          ...preState,
          ["engagement_isEmpty"]: "Enagagement type can not be empty",
        }));
      }
    }
  };

  const onSubmitValidation = async () => {
    await setFormErrors({});
    //formErrorObj = {};

    if (!customerSelectData || Object.keys(customerSelectData).length === 0) {
      setFormErrors((preState) => ({
        ...preState,
        ["customer_isEmpty"]: "customer cannot be empty",
      }));
      FormErrors["customer_isEmpty"] = "customer cannot be empty";
    }

    if (!selectedEngagement || Object.keys(selectedEngagement).length === 0) {
      setFormErrors((preState) => ({
        ...preState,
        ["engagement_isEmpty"]: "Engagement cannot be empty",
      }));
      FormErrors["engagement_isEmpty"] = "Engagement cannot be empty";
    }
  };

  const ResetFunction = () => {
    setSelectedEngagement("");
    setEngagementOptions([]);
    setRequirementReportData([]);
    setCustomerSelectData("");
  };

  const GetRequirementReportGridData = async () => {
    await showLoader();
    let requestParams = {
      start: start,
      pageSize: pageSize,
      sortColumn: sortColumn === "" ? "Title" : sortColumn,
      sortOrder: sortDirection === "" ? "Desc" : sortDirection,
      searchText: searchText,
      EngagementId:
        selectedEngagement && selectedEngagement.value
          ? selectedEngagement.value
          : selectedEngagement.value,
    };

    const { data } = await APICall(
      getRequirmentReportGridData,
      "POST",
      requestParams
    );

    if (data && data.length > 0) {
      setRequirementReportData(data);
      setCount(data[0].count);
      await hideLoader();
    } else {
      setPage(0);
      setStart(0);
      setCount(0);
      setRequirementReportData(data);
      await hideLoader();
    }
  };

  const onClickFunction = async (action) => {
    let requestObject;
    if (action === "submit") {
      showLoader();
      await onSubmitValidation();

      const isEmpty = await Object.values(FormErrors).every(
        (x) => x === null || x === "" || x == undefined
      );

      if (isEmpty == true) {
        await GetRequirementReportGridData();
      }
      hideLoader();
    }
  };

  const ExportToExcel = async () => {
    showLoader();

    let requestParams = {
      start: start,
      pageSize: count,
      sortColumn: sortColumn === "" ? "Title" : sortColumn,
      sortOrder: sortDirection === "" ? "Desc" : sortDirection,
      searchText: searchText === "" ? "" : searchText,
      EngagementId: selectedEngagement.value,
    };

    axios
      .request({
        responseType: "blob",
        method: "POST",
        url: GetRequirementReportExportToExcel,
        data: requestParams,
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
          "Access-Control-Allow-Headers": "*",
        },
      })
      .then((response) => {
        fileDownload(response.data, "Requirement Report.xlsx");
      })
      .catch((error) => {
        console.error(error.response.data);
      });
    hideLoader();
  };

  const [toggle, setToggle] = useState(false);
  const toggleFilter = () => {
    setToggle(!toggle);
  };

  return (
    <>
      <Heading title={"Requirement Report"} />

      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-12">
            <div className="d-flex justify-content-end gap-2">
              <button
                onClick={() => ExportToExcel()}
                className="btn btn-export"
              >
                Export to Excel
              </button>
              <a className="filterIcon" onClick={toggleFilter}>
                <i className="fa fa-filter"></i>
              </a>
            </div>
          </div>

          <div className="col-lg-12">
            {toggle && (
              <div className="row mt-3" id="filterContent">
                <div className="col-lg-4 col-md-4 col-sm-6">
                  <div className="form-group">
                    <label>
                      Select Customer <sup>*</sup>{" "}
                    </label>
                    <SelectForm
                      options={customerOptions}
                      placeholder="Select Customer"
                      value={
                        Object.keys(customerSelectData).length != 0
                          ? customerSelectData
                          : ""
                      }
                      onChange={(event) => selectOnChange(event, "customer")}
                      isMulti={false}
                      noIndicator={false}
                      noSeparator={false}
                    />
                    <p style={{ color: "red" }}>
                      {FormErrors["customer_isEmpty"]}
                    </p>
                  </div>
                </div>
                <div className="col-lg-4 col-md-4 col-sm-6">
                  <div className="form-group">
                    <label>
                      Select Engagement <sup>*</sup>{" "}
                    </label>
                    <SelectForm
                      options={EngagementOptions}
                      placeholder="Select Engagement"
                      value={
                        Object.keys(selectedEngagement).length != 0
                          ? selectedEngagement
                          : ""
                      }
                      onChange={(event) => selectOnChange(event, "engagement")}
                      isMulti={false}
                      noIndicator={false}
                      noSeparator={false}
                    />
                    <p style={{ color: "red" }}>
                      {FormErrors["engagement_isEmpty"]}
                    </p>
                  </div>
                </div>
                <div className="col-lg-12">
                  <div className="d-flex justify-content-end gap-2">
                    <button
                      onClick={() => ResetFunction()}
                      className="btn btn-reset"
                      // disabled={state !== null ? true : false}
                    >
                      Reset
                    </button>
                    <button
                      onClick={() => onClickFunction("submit")}
                      className="btn btn-submit"
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
          <div className="col-lg-12 mt-3">
            {
              <DynamicGrid
                options={options}
                data={RequirementReportData}
                columns={gridColumns}
              />
            }
          </div>
        </div>
      </div>
    </>
  );
}

export default RequirementReport;
